
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22 22H2V2h20v20zM10.816 4.05c-.643-.118-1.323 0-1.962.047-.169.012-.271-.131-.416.03-.073.08-.145.39-.157.513-.068.719.132 1.416.149 2.064.029 1.153-.01 2.344.008 3.508.01.788-.025 1.584 0 2.371.002.079-.004.158 0 .237.014.336.044.819.08 1.147.006.055.012.12.076.117-.021.118-.163.273-.198.433-.03.13-.001.41-.064.496-.272.367-.323.292-.5.869-.191.626-.178.972-.204 1.56-.003.072-.12.15-.128.199-.011.08.43 1.374.49 1.52.034.082.48.71.525.733.366.18.624-.122.728-.107.088.013.199.187.342.211.054.009.973-.047 1.082-.062.135-.018 1.389-.456 1.445-.511.286-.286.388-1.796.475-1.852.432-.184 1.887.249 1.94-.406.018-.224-.168-.452-.04-.713.02-.039.562-.49.638-.54.143-.093.556-.196.635-.268.042-.04.006-.126.016-.14.024-.028.068-.057.079-.078.01-.023.12-.01.078-.158l-.31-.119c.191-.236.69-.237.466.118.166-.029.56.142.625-.079a.28.28 0 000-.079c.365.057.949-.07.744-.55l-.001.002c-.2-.468-.618-.16-.354-1.189.015-.058-.035-.187.012-.229.048-.04.212.034.227-.05.023-.132-.059-.288-.047-.397.017-.156.236-.314.043-.431-.165-.1-.663-.407-.798-.38-.094.02-1.17.488-1.262.548-.162.105-.188.277-.337.37-.458.285-2.053.638-2.693.91-.324.14-.255.387-.61.21.083-.133.146-.17.158-.35.035-.557-.268-1.266-.236-1.861.031-.568.217-1.243.238-1.855.015-.424-.04-.892-.09-1.338a12.791 12.791 0 00-.066-.747 3.665 3.665 0 010-.363c.014-.244.276-.581.313-.948.053-.53-.062-1.76-.509-2.102-.051-.039-.574-.299-.63-.31z","fill":"#95C636"}})])
          )
        }
      }
    